import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from "react-router";
import ResumeButton from "../../Buttons/ResumeButton/ResumeButton";
import ResumeLogo from "../../Icons/MediumIcon/EditorLogo";
import { Navbar, Dropdown, Nav } from "react-bootstrap";
import AccountDropdown from "../../DropdownComponent/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { resumeEditActions } from "../../../Store/Actions/ResumeActions";
import { coverEditActions } from "../../../Store/Actions/CoverLetterActions";
import { useParams } from "react-router-dom";
import { selectAllText } from "../../../Utils/Common";
import { shortString } from "../../../Utils/Common";
import { timeDifference } from "../../../Utils/Common";
import SmallIcon from "../../Icons/SmallIcon/SmallIcon";
import { logout } from "../../../Store/Actions/authActions";
import { userTypeContext } from "../../../Context/FreeOrProContext";
import { ExternalUserContext } from "../../../Context/externalUserContext";
import { pageLayoutContext } from "../../../Context/PageLayoutContext";
import "./EditorHeader.scss";
import LoginPopup from "../../Modals/LoginPopup/LoginPopup";
import ReactTooltip from "react-tooltip";
import EditorSpinner from "../../../Utils/EditorSaveSpinner";

function EditorHeader(props) {
  const selectRef = useRef();
  const history = useHistory();
  const { id } = useParams();
  const [title, setTitle] = useState("");
  const [time, setTime] = useState("");
  const [type, setType] = useState("login");
  const path = window.location.pathname;
  const dispatch = useDispatch();
  const [btnCheck, setBtnCheck] = useState(false);
  const { userType, resumeCount } = useContext(userTypeContext);
  const { isLogin, setIsLogin } = useContext(ExternalUserContext);
  const { showFeedback, setShowFeedback } = useContext(pageLayoutContext);

  const [showLogin, setShowLogin] = useState(false);

  const resume = useSelector((state) => state.resumeLastUpdatedAt);
  const cover = useSelector((state) => state.coverLastUpdatedAt);
  const savedTime = useSelector((state) => state.resumeLastUpdatedAt);

  const onSelect = (e) => {
    // setDrop(e)
  };
  const handleBlur = (e) => {
    var title = e.target.innerText.trim();
    setTitle(`${e.target.innerText.trim()} `);
    if (path && path.includes("coverletter")) {
      dispatch(coverEditActions(id, { title: title }));
    } else {
      dispatch(resumeEditActions(id, { title: title }));
    }
  };

  const titleChange = (e) => {
    if (e.key == "Enter" || e.keyCode == 13) {
      e.preventDefault();
      handleBlur(e);
    }
  };

  const handleFocus = (event) => {
    if (btnCheck) {
      setBtnCheck(false);
      selectAllText(event);
    }
  };
  const focusHeader = () => {
    setBtnCheck(true);
  };

  useEffect(() => {
    if (path && path.includes("cover")) {
      if (cover && cover.title) {
        setTitle(cover.title);
      }
    } else {
      if (resume && resume.title) {
        setTitle(resume.title);
      }
    }
  }, [resume, cover]);

  useEffect(() => {
    if (btnCheck) {
      selectRef.current.focus();
    }
  }, [btnCheck]);

  useEffect(() => {
    var interval = "";
    if (savedTime && savedTime.date) {
      let updated = timeDifference(savedTime.date);
      setTime(updated);

      interval = setInterval(() => {
        let updated = timeDifference(savedTime.date);
        setTime(updated);
      }, 10000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [savedTime]);
  //Content For Dropdown

  const onLogout = () => {
    if (props.path.includes("resumes")) {
      props.setLeaveUrl("/logout");
      props.setShowClosePopup(true);
      props.resumeUpdateToServer();
      dispatch(logout());
    } else {
      dispatch(logout());
    }
  };

  const onRedirect = () => {
    if (props.path.includes("resumes")) {
      props.setLeaveUrl("/myaccount");
      props.setShowClosePopup(true);
      props.resumeUpdateToServer();
      history.push("/myaccount");
    } else {
      history.push("/myaccount");
    }
  };

  const onHelp = () => {
    setShowFeedback(true);
  };

  const Dropdownitem = [
    {
      eventKey: "Name  - Sort by ASC",
      key: "asc",
      onClickItem: onRedirect,
      sort: "name",
      name: "Account Settings",
    },
    {
      eventKey: "Name - Sort by DESC",
      key: "desc",
      sort: "name",
      name: "Support",
      onClickItem: onHelp,
    },
    {
      eventKey: "Date - Sort by ASC",
      key: "asc",
      onClickItem: onLogout,
      sort: "updated_at",
      name: "Logout",
    },
  ];

  const openModalFunction = (title, type, value) => {
    value();
  };

  const handleUpgrade = () => {
    if (props.path.includes("resumes")) {
      props.setLeaveUrl("/pricingplansnew");
      props.setShowClosePopup(true);
      props.resumeUpdateToServer();
      history.push("/pricingplansnew");
    } else {
      history.push("/pricingplansnew");
    }
  };

  const gotoHome = () => {
    if (props.path.includes("resumes")) {
      props.setLeaveUrl("/home");
      props.setShowClosePopup(true);
      props.resumeUpdateToServer();
      history.push("/home");
    } else {
      history.push("/home");
    }
  };
  const handleLogin = (type) => {
    setType(type);
    setShowLogin(true);
  };
  const handleHide = () => {
    setShowLogin(false);
  };

  return (
    <>
      <ReactTooltip padding="8px 12px" />
      <Navbar
        bg="white"
        className="sticky-editor-navigation"
        style={{ padding: "0" }}
      >
        <Navbar.Brand
          data-padding="8px 12px"
          onClick={() => gotoHome()}
          className="qlogo"
        >
          <ResumeLogo
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/Qlogo.svg`}
          />
        </Navbar.Brand>
        <LoginPopup
          show={showLogin}
          hide={handleHide}
          type={type}
          resumeFields={props.resumeFields}
          setResumeFields={props.setResumeFields}
        />
        <div className="d-flex align-items-center resumedetails">
          <div id="flex" className=" position-relative">
            <div
              className="resume-header-title input-editable-focus"
              ref={selectRef}
              contentEditable={true}
              suppressContentEditableWarning={true}
              onBlur={handleBlur}
              onKeyPress={titleChange}
              onFocus={handleFocus}
              dangerouslySetInnerHTML={{ __html: shortString(title, 40) }}
            />
            <SmallIcon
              src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/edit-pencil.png`}
              className="resumetitleicon cursor-pointer"
              onClick={() => focusHeader()}
            />
          </div>
        </div>
        <div
          className="d-flex"
          style={{ float: "right", marginLeft: "20px", color: "#afb4b5" }}
        >
          <div>
            {isLogin && isLogin ? (
              <EditorSpinner />
            ) : (
              <span
                className="saveyourwork-info"
                onClick={() => setShowLogin(true)}
              >
                {" "}
                <i class="fa fa-info-circle mr-2" aria-hidden="true"></i> Sign
                up to save your work
              </span>
            )}
          </div>
        </div>
        {props && !props.isMobile && (
          <>
            {path?.includes("resumes") && (
              <div className="d-flex ml-5">
                <div style={{ position: "relative" }}>
                  <p
                    className={`m-0 mr-5 editor_tab ${
                      !props.isVisualEditor ? "active_editor" : ""
                    }`}
                    onClick={() => props.handleEditor("basic")}
                  >
                    Basic Editor
                  </p>
                  <div class="underline"></div>
                </div>
                <div style={{ position: "relative" }}>
                  <p
                    className={`m-0 editor_tab  ${
                      props.isVisualEditor ? "active_editor" : ""
                    }`}
                    onClick={() => props.handleEditor("visual")}
                  >
                    Visual Editor
                  </p>
                  <div class="underline"></div>
                </div>
              </div>
            )}
          </>
        )}

        <div className=" d-block d-sm-block d-md-none d-lg-none d-xl-none ml-4">
          <div className="" onClick={props.handleMediumDesignbar}>
            <div className="editor-header-ellipsis">
              <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        {isLogin && isLogin ? (
          <Navbar.Collapse className="justify-content-end">
            {userType && userType == "free" ? (
              <Navbar.Text className="d-none d-md-block">
                <ResumeButton
                  success
                  left_icon
                  title="Upgrade to Pro"
                  src="/images/zap.svg"
                  onClick={handleUpgrade}
                />
              </Navbar.Text>
            ) : (
              ""
            )}

            <AccountDropdown
              src
              Dropdownitem={Dropdownitem}
              drop={""}
              onSelect={onSelect}
              className="profdrpdwn account-dropdown "
              itemClassName="accountlink"
              onClick={openModalFunction}
            />
          </Navbar.Collapse>
        ) : (
          <>
            <Navbar.Collapse className="justify-content-end">
              <ResumeButton
                success
                className="mr-2"
                title="Sign In"
                onClick={() => handleLogin("login")}
              />
              <ResumeButton
                success
                title="Sign Up"
                onClick={() => handleLogin("signup")}
              />
            </Navbar.Collapse>
          </>
        )}
      </Navbar>
    </>
  );
}

export default EditorHeader;
